// Copyright 1999-2020. Plesk International GmbH. All rights reserved.
import React, { Children, cloneElement, isValidElement } from 'react';

/**
 * `Tour` component is used for introducing a new functionality in the product.
 * The component consists of several [Spots](#!/Spot), each of them highlighting a specific feature
 * or element you want to focus user attention on.
 * @since 2.7.0
 */
const Tour = ({
  current,
  children,
  onClose
}) => {
  const spots = Children.toArray(children);

  if (current !== undefined && current in spots) {
    const spot = spots[current];

    if ( /*#__PURE__*/isValidElement(spot)) {
      let popup;

      if (onClose && spot.props.popup) {
        popup = { ...spot.props.popup,
          onClose
        };
      }

      const props = {
        key: current,
        meta: {
          current,
          total: spots.length
        },
        popup
      };
      return /*#__PURE__*/cloneElement(spot, props);
    }
  } // a workaround for Props & Methods in Styleguidist
  // eslint-disable-next-line no-constant-condition


  if (false) {
    return /*#__PURE__*/React.createElement("span", null);
  }

  return null;
};

export default Tour;